import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { createStructuredSelector } from "reselect";
import { getPost } from "../../Containers/PostContainer/action";
import { selectPostData } from "../../Containers/PostContainer/selector";
import { selectProfile } from "../../Containers/Client/selector";

import Profile from "../../Components/Profile";

import { useLocation } from "react-router-dom";
import Post from "../../Components/Post";
import { selectVisitedProfile } from "./selector";
import { selectIsLoading } from "../../Containers/App/selector";

import style from "./style.module.scss";

const Home = ({ posts, isLoading, profile, visitedProfile }) => {
	const dispatch = useDispatch();
	const location = useLocation();

	const [followedBy, setFollow] = useState(null);
	const [followers, setFollowers] = useState(null);

	const pathUsername = location?.pathname?.split("/")[1];
	useEffect(() => {
		if (pathUsername) {
			dispatch(getPost("myjourney", pathUsername, null, true));
		} else {
			dispatch(getPost("myjourney", profile.username));
		}
	}, [pathUsername]);

	if ((pathUsername && visitedProfile) || !pathUsername) {
		const data = pathUsername ? visitedProfile.profile : profile;
		return (
			<div className={style.container}>
				<Profile
					profile={data}
					followedBy={
						pathUsername
							? followedBy
								? followedBy
								: visitedProfile.followedBy
							: null
					}
					followers={followers ? followers : data.followersCount}
					setFollowers={setFollowers}
					setFollowed={setFollow}
					following={data.followingCount}
					isHome={!(pathUsername && data.username !== profile.username)}
				/>
				<div className={style.right}>
					<div className={style.rightChild}>
						<div className={style.content}>
							{!isLoading && posts?.length > 0 ? (
								posts.map((post, index) => {
									return (
										<Post
											data={post}
											loggedInUser={profile.username}
											key={index}
										/>
									);
								})
							) : (
								<div className={style.noPost}>
									{isLoading
										? "Please wait..."
										: pathUsername
										? `User don't have any marks.. :(`
										: "Create your first mark!"}
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
};

const mapStateToProps = createStructuredSelector({
	posts: selectPostData,
	isLoading: selectIsLoading,
	profile: selectProfile,
	visitedProfile: selectVisitedProfile,
});

export default connect(mapStateToProps)(Home);
